import React from 'react';
import { media, stylesheet } from 'typestyle';
import { White } from '@traceair/tds';
import { BREAKPOINT_MEDIUM } from '../styles';

const css = stylesheet({
  container: {
    flex: '1 1 auto',
    borderRadius: '24px 0 0 24px',
    background: White,
    boxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.05)',
    ...media(
      { maxWidth: BREAKPOINT_MEDIUM },
      {
        borderRadius: 0,
      },
    ),
  },
  containerInner: {
    height: '100%',
    overflow: 'hidden',
  },
});

interface Props {
  children: React.ReactNode;
}

export const Content = ({ children }: Props) => {
  return (
    <div className={css.container}>
      <div className={css.containerInner}>{children}</div>
    </div>
  );
};
